var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12 2.23999H26.88",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12 6.71997H14.56",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 6.71997H22.4",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.76 53.76V29.12L14.56 21.28L3.35999 29.12V53.76H25.76Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.64 53.76V29.12L41.44 21.28L30.24 29.12V53.76H52.64Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95996 50.4V34.72",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.16 50.4V34.72",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5599 50.4V34.72",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.84 50.4V34.72",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.04 50.4V34.72",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4399 50.4V34.72",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35999 34.72H25.76",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.24 34.72H52.64",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35999 30.24H25.76",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12 16.8H54.88",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12 12.3199H54.88",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.24 30.24H52.64",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59998 12.3199V16.7999",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.08 12.3199V16.7999",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.04 12.3199V16.7999",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.52 12.3199V16.7999",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.48 12.3199V16.7999",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.96 12.3199V16.7999",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.92 12.3199V16.7999",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 12.3199V16.7999",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12 53.76H54.88",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilos);
export default __webpack_public_path__ + "static/media/silos.b612f316994ea6b873999175a905aad2.svg";
export { ForwardRef as ReactComponent };